import axios from "@/axios.js"
import http from "axios"

export default {
  getCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var path = payload.curriculum_year == 2022 ? "category_2022" : "category/-1"
      axios.get("/api/v2/subject/" + path)
        .then((response) => {
          console.log(response.data)
          if (response.data.result == 'success') {
            commit('SET_CATEGORY_LIST', response.data.data_list)
            resolve(response)
            return
          }
          throw new Error("Invalid response");
        })
        .catch((error) => {
          if (error.message === "Invalid response") {
            alert("서버 응답이 올바르지 않습니다. 관리자에게 문의해주세요.");
          } else {
            alert("데이터를 가져오는 데 실패했습니다.");
          }
          throw error
        })

    })
  },
  getMainCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var pathParameter = payload.curriculum_year == 2022 ? 'main_category_2022?category_id=' + payload.category_id : 'main-category?id=' + payload.category_id
      axios.get("/api/v2/subject/" + pathParameter)
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_MAIN_CATEGORY_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSubCategoryList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var pathParameter = payload.curriculum_year == 2022 ? 'sub_category_2022?main_category_id=' + payload.main_category_id : 'sub-category?id=' + payload.main_category_id
      axios.get("/api/v2/subject/" + pathParameter)
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_SUB_CATEGORY_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getConceptBookData({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/category/concept_book', { params: payload })
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_CONCEPT_BOOK_DATA', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getConceptBookDataOnly(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/category/concept_book', { params: payload })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTextbookConceptBookData({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/textbook_content/concept_book', { params: payload })
        .then((response) => {
          if (response.data.result == 'success') {
            // console.log(response.data.data)
            commit('SET_CONCEPT_BOOK_DATA', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTextbookConceptBookDataOnly(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/textbook_content/concept_book', { params: payload })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLiteratureConceptBookData({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/literature/concept_book_path', { params: payload })
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_CONCEPT_BOOK_DATA', {
              concept_book_origin_info: {},
              concept_book_info: response.data.path
                ? {
                    id: payload.literature_id,
                    path: response.data.path,
                    create_time: response.data.create_time,
                  }
                : {},
            })
            resolve(response)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  uploadConceptBookOrigin({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/contents/category/concept_book_origin', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  updateConceptBookOrigin(_, formData) {
    return axios.put('/api/v2/contents/concept_book_origin', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((response) => {
      if (response.data.result !== 'success') return Promise.reject(response)
      return response
    })
  },
  uploadLiteratureConceptBookOrigin({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/contents/literature/concept_book', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  uploadTextbookConceptBookOrigin({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/contents/textbook_content/concept_book_origin', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') resolve(response)
          else reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  uploadTextbookConceptBookScriptOrigin({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/contents/textbook_content/concept_book_script_origin', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') resolve(response)
          else reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  async downloadConceptBook(_, payload) {
    try {
      const response = await axios.post(
        '/api/v2/contents/concept_book/download',
        payload,
        { responseType: 'blob' } // 파일로 받기
      )
      const contentType = response.headers['content-type']

      // 응답이 PDF가 아닐 경우 (예: application/json)
      if (contentType && !contentType.includes('pdf')) {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const json = JSON.parse(reader.result)
            alert(json.detail || '파일을 다운로드할 수 없습니다.')
          } catch {
            alert('다운로드 중 오류가 발생했습니다.')
          }
        }
        reader.readAsText(response.data)
        return
      }

      // ✅ 정상 PDF일 때만 다운로드 처리
      // Blob 변환 및 브라우저 다운로드
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = payload.file_name
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('다운로드 오류:', error)
      throw error
    }
  },
  // PDF 미리보기용 (다운로드 없이 blob 반환)
  async getConceptBookPreview(_, payload) {
    try {
      const response = await axios.post(
        '/api/v2/contents/concept_book/download',
        payload,
        { responseType: 'blob' }
      )
      const contentType = response.headers['content-type']

      // 응답이 PDF가 아닐 경우
      if (contentType && !contentType.includes('pdf')) {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const json = JSON.parse(reader.result)
            throw new Error(json.detail || 'PDF를 불러올 수 없습니다.')
          } catch (e) {
            if (e.message) throw e
            throw new Error('PDF를 불러오는 중 오류가 발생했습니다.')
          }
        }
        reader.readAsText(response.data)
        return null
      }

      // PDF blob 반환
      return response
    } catch (error) {
      console.error('PDF 미리보기 오류:', error)
      throw error
    }
  },
  // 개념서 교체(보통 디자인 2차 편집한 경우)
  updateConceptBook(_, formData) {
    return axios.put('/api/v2/contents/concept_book/update', formData, {
      timeout: 300000,
    }).then(response => {
      if (response.data.result === 'success' || response.data.local_saved) return response
      throw response
    })
  },
  updateLiteratureConceptBook({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/contents/literature/concept_book', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => reject(error))
    })
  },
  // 출판사 리스트
  getPublisherList({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/exam/publisher')
        .then((res) => {
          commit('SET_PUBLISHER_LIST', res.data.data_list)
          resolve(res)
        })
        .catch(reject)
    })
  },

  // 책분류 리스트
  getTextbookPublisherList({ commit }, publisherId) {
    console.log(publisherId)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/textbook_publisher/all?publisher_id=${publisherId}`)
        .then((res) => {
          commit('SET_TEXTBOOK_PUBLISHER_LIST', res.data.data_list)
          resolve(res)
        })
        .catch(reject)
    })
  },

  getTextbookSubjectList({ commit }, { textbookId, subjectTypeId }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v2/exam/textbook_subject?textbook_id=${textbookId}`)
        .then((res) => {
          const hasSubjectTypeFilter = subjectTypeId !== undefined && subjectTypeId !== null && subjectTypeId !== ''
          const filtered = hasSubjectTypeFilter
            ? (res.data.data_list || []).filter(
              (item) => Number(item.subject_type_id) === Number(subjectTypeId)
            )
            : (res.data.data_list || [])
          commit('SET_TEXTBOOK_SUBJECT_LIST', filtered)
          resolve(filtered)
        })
        .catch(reject)
    })
  },

  // 대중소 목차 리스트
  getTextbookContentList({ commit }, subjectId) {
    return Promise.all([
      axios.get(`/api/v2/exam/textbook_content_subject?subject_id=${subjectId}`),
      axios.get(`/api/v2/exam/textbook_content_main_subject?subject_id=${subjectId}`),
      axios.get(`/api/v2/exam/textbook_content_sub_subject?subject_id=${subjectId}`)
    ])
      .then(([content, main, sub]) => {
        commit('SET_TEXTBOOK_CONTENT_LIST', content.data.data_list)
        commit('SET_TEXTBOOK_CONTENT_MAIN_LIST', main.data.data_list)
        commit('SET_TEXTBOOK_CONTENT_SUB_LIST', sub.data.data_list)
      })
  },

  // 빈칸 문제 조회
  getMemorize(_, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/memorize', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 빈칸 문제 수정
  updateMemorize(_, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/memorize', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 대화문 암기 문장 조회
  getScriptSentences(_, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/script_sentence', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 대화문 암기 문장 수정
  updateScriptSentence(_, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/script_sentence', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 빈칸 문제 삭제
  deleteMemorize(_, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v2/contents/concept_book/memorize', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  //ox
  getOxQuiz(_, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/ox_quiz', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  deleteOxQuiz(_, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v2/contents/concept_book/ox_quiz', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateOxQuiz(_, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/ox_quiz', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  requestConceptBook(_, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/contents/concept_book/request', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getWhiteNotes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/get_white_note', { params: payload })
        .then((response) => {
          if (response.data.result === '백지노트 조회 완료') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  createWhiteNote({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/create_white_note', payload)
        .then((response) => {
          if (response.data.result === '백지노트 생성 완료') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  resetWhiteNotes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/reset_white_note', { data: payload })
        .then((response) => {
          if (response.data.result === '백지노트 전체 초기화 완료') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 관리 > 문제 관리 > 개념서 문제 생성 페이지
  // 개념서 목록 + 현재 make_question(1=객관식/2=서술형/3=수학예제/4=이미지 전제형, null=대기 없음) 조회
  searchConceptBookQuestionManageList(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/question_manage/list', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 개념서 1건의 make_question 값 변경 (payload.make_question = null이면 대기 없음으로 리셋)
  setConceptBookQuestionManageMakeQuestion(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/question_manage/make_question', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 특정 개념서로부터 이미 생성된 문제 목록 조회
  getConceptBookQuestionManageQuestions(context, params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/question_manage/questions', { params })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 개념서 기반 생성 문제 1건 승인 (is_text=4) — 이미 is_text=5인 문제는 백엔드에서 거부됨
  approveConceptBookQuestion(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/question_manage/question/approve', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 개념서 1권으로 생성된 문제 중 is_text=3인 것만 일괄 승인
  approveAllConceptBookQuestions(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/question_manage/questions/approve_all', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 개념서 기반 생성 문제 1건 삭제 — is_text=3인 문제만 백엔드에서 허용됨
  deleteConceptBookQuestion(context, questionId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v2/contents/concept_book/question_manage/question/${questionId}`)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  approveSelectedConceptBookQuestions(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v2/contents/concept_book/question_manage/questions/approve_selected', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  deleteSelectedConceptBookQuestions(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/contents/concept_book/question_manage/questions/delete_selected', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  updateWhiteNote({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/update_white_note', payload)
        .then((response) => {
          if (response.data.result === '백지노트 수정 완료') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  deleteWhiteNote({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/delete_white_note', { data: payload })
        .then((response) => {
          if (response.data.result === '백지노트 삭제 완료') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 개념서 완전 삭제 (원본 + 생성물 전체) - 개발/운영 서버에 반영된 개념서는 백엔드에서 거부됨
  deleteConceptBookFull(_, payload) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v2/contents/concept_book/${payload.concept_book_id}`)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 개념서에 속한 목차(concept_book_content) 목록 - OX퀴즈/빈칸 수동 추가 대상 선택용
  getConceptBookContentList(_, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v2/contents/concept_book/content', { params: payload })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // ox퀴즈 수동 추가
  createOxQuiz(_, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/contents/concept_book/ox_quiz', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // 빈칸 문제 수동 추가
  createMemorize(_, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v2/contents/concept_book/memorize', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
